"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _callIfFunc = _interopRequireDefault(require("../call-if-func"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Hook for toggling a value, with optional callback
 * @param {function} [callback] Triggered with event args when toggle is invoked
 * @returns {[value, toggle]} [state, toggle]
 */
var useToggle = function useToggle(initialValue, callback) {
  if (initialValue === void 0) {
    initialValue = false;
  }

  if (callback === void 0) {
    callback = false;
  }

  var _useState = (0, _react.useState)(initialValue),
      value = _useState[0],
      setValue = _useState[1];

  var toggle = (0, _react.useCallback)(function () {
    for (var _len = arguments.length, event = new Array(_len), _key = 0; _key < _len; _key++) {
      event[_key] = arguments[_key];
    }

    _callIfFunc["default"].apply(void 0, [callback].concat(event, [!value]));

    setValue(!value);
  }, [callback, value]);
  return [value, toggle];
};

var _default = useToggle;
exports["default"] = _default;